module.exports = __webpack_public_path__ + "static/media/05EchoMountainbackroundpainting.1a299f1f.webp";